import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Spinner,
  Box,
  BlockStack,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { XIcon, CheckIcon } from "@shopify/polaris-icons";
import Select2 from "react-select";
import moment from "moment";

const OrderDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [optionsProfessors, setOptionsProfessors] = useState([]);
  const [selectedProfessor, setSelectedProfessor] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  const handleSelectChangeProfessor = (newValue) => {
    setSelectedProfessor(newValue);
  };
  const [activeModal, setActiveModal] = useState(false);
  const [activeModalReject, setActiveModalReject] = useState(false);
  const [activeModalApprove, setActiveModalApprove] = useState(false);
  const [ts, setTs] = useState("");

  const handleSubmit = () => {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("status", 2);
    form_data.append("professor_id", selectedProfessor);
    setIsSaving(true);
    axios
      .post(`/orders/${id}/edit-status`, form_data)
      .then((result) => {
        setIsSaving(false);
        setActiveModal(false);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleReject = () => {
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("status", 3);
    setIsSaving(true);
    axios
      .post(`/orders/${id}/edit-status`, form_data)
      .then((result) => {
        setIsSaving(false);
        setActiveModalReject(false);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleApprove = () => {};
  const handleChangeModal = () => {
    setActiveModal(false);
  };

  const handleChangeModalReject = () => {
    setActiveModalReject(false);
  };
  const handleChangeModalApprove = () => {
    setActiveModalApprove(false);
  };
  const [result, setResult] = useState("");
  useEffect(() => {
    fetchData();
  }, [ts]);

  async function fetchData() {
    // let responseProfessors = "";
    let responseItem = "";

    try {
      responseItem = await axios.get(`/orders/${id}`);

      setResult(responseItem.data.data);
      responseItem.data.data.professor &&
        responseItem.data.data.professor.id !== null &&
        setSelectedProfessor(String(responseItem.data.data.professor.id));
    } catch (error) {
      console.log(error);
    }

    // try {
    //   responseProfessors = await axios.get(
    //     `/professors${
    //       responseItem?.data?.data.subject
    //         ? `?filter[subjects.id]=${responseItem?.data?.data.subject.id}`
    //         : ""
    //     }`
    //   );
    //   setOptionsProfessors(
    //     responseProfessors.data.data.data.map((item, index) => {
    //       return {
    //         label: item?.name && getFirstNonNullValue(item.name),
    //         value: String(item.id),
    //       };
    //     })
    //   );
    // } catch (error) {
    //   console.log(error);
    // }
  }
  const switchStatusColor = (param) => {
    switch (String(param)) {
      case "1":
        return "default";
      case "2":
        return "success";
      case "3":
        return "critical";
      default:
        return "";
    }
  };
  return result ? (
    <Page
      // narrowWidth
      backAction={{ onAction: () => navigate("/admin/orders") }}
      title={result?.user?.name}
      // titleMetadata={
      //   <Badge tone={switchStatusColor(result?.status?.id)}>
      //     {result?.status?.description}
      //   </Badge>
      // }
    >
      <Card roundedAbove="sm">
        {/* <Text as="h3" variant="headingSm" fontWeight="medium">
              USER DETAILS
            </Text> */}
        <FormLayout>
          <FormLayout.Group condensed>
            <Text>
              <b>Username</b>
              <br /> {result?.user?.name ? result?.user?.name : "-"}
            </Text>
            <Text>
              <b>Email</b>
              <br /> {result?.user?.email ? result?.user?.email : "-"}
            </Text>
            <Text>
              <b>Phone Number</b>
              <br /> {result?.user?.phone ? result?.user?.phone : "-"}
            </Text>
          </FormLayout.Group>
          <FormLayout.Group condensed>
            <Text>
              <b>Created at</b>
              <br />
              {result?.created_at
                ? moment(result?.created_at).format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </Text>
            <Text>
              <b> Course / Lecture / Note Purchased</b>
              <br />
              {result?.course
                ? getFirstNonNullValue(result?.course?.title)
                : result?.lecture
                ? getFirstNonNullValue(result?.lecture?.name)
                : getFirstNonNullValue(result?.note?.name)}
            </Text>
            <Text>
              <b>Amount</b>
              <br />
              {result?.purchased_price !== null ? result?.purchased_price : "-"}
            </Text>
          </FormLayout.Group>
          <FormLayout.Group condensed>
            <Text>
              <b>Payment Method</b>
              <br />
              {result?.verified_from ? result?.verified_from : "-"}
            </Text>
            <Text></Text>
            <Text></Text>
          </FormLayout.Group>
          {/* <FormLayout.Group condensed>
                {result?.professor && (
                  <Text>
                    <b>Professor</b>
                    <br />{" "}
                    {result?.professor && result?.professor?.name
                      ? getFirstNonNullValue(result?.professor?.name)
                      : "-"}
                  </Text>
                )}
                {result?.subject && (
                  <Text>
                    <b>Subject</b>
                    <br />{" "}
                    {result?.subject && result?.subject?.name
                      ? getFirstNonNullValue(result?.subject?.name)
                      : "-"}
                  </Text>
                )}
                <Text></Text>
              </FormLayout.Group> */}
        </FormLayout>

        {/* <Box paddingBlockStart="200">
          <BlockStack gap="200">
            <Text as="h3" variant="headingSm" fontWeight="medium">
              COURSE DETAILS
            </Text>
            <FormLayout>
              <FormLayout.Group condensed>
                <Text>
                  <b>Name</b>
                  <br />
                  {result?.course && result?.course?.name
                    ? getFirstNonNullValue(result?.course?.name)
                    : "-"}
                </Text>
                <Text>
                  <b>Description</b>
                  <br />
                  {result?.course && result?.course?.description
                    ? getFirstNonNullValue(result?.course?.description)
                    : "-"}
                </Text>
                <Text>
                  <b>Price</b>
                  <br />
                  {result?.course && result?.course?.price !== null
                    ? result?.course?.price
                    : "-"}
                </Text>
              </FormLayout.Group>
              <FormLayout.Group condensed>
                {result?.professor && (
                  <Text>
                    <b>Professor</b>
                    <br />
                    {result?.professor && result?.professor?.name
                      ? getFirstNonNullValue(result?.professor?.name)
                      : "-"}
                  </Text>
                )}
                {result?.subject && (
                  <Text>
                    <b>Subject</b>
                    <br />
                    {result?.subject && result?.subject?.name
                      ? getFirstNonNullValue(result?.subject?.name)
                      : "-"}
                  </Text>
                )}
                <Text></Text>
              </FormLayout.Group>
            </FormLayout>
          </BlockStack>
        </Box> */}
      </Card>

      <Modal
        open={activeModal}
        onClose={handleChangeModal}
        title="Approve Order"
        primaryAction={{
          content: "Submit",
          onAction: handleSubmit,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            loading: isSaving,
            onAction: handleChangeModal,
          },
        ]}
      >
        <Modal.Section>
          <Select
            label="Please assign a professor"
            options={optionsProfessors}
            onChange={handleSelectChangeProfessor}
            value={selectedProfessor}
            placeholder="Please select"
          />
        </Modal.Section>
      </Modal>

      <Modal
        open={activeModalReject}
        onClose={handleChangeModalReject}
        title="Reject Order"
        primaryAction={{
          content: "Yes",
          onAction: handleReject,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalReject,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to reject this order?</Text>
        </Modal.Section>
      </Modal>

      <Modal
        open={activeModalApprove}
        onClose={handleChangeModalApprove}
        title="Reject Order"
        primaryAction={{
          content: "Yes",
          onAction: handleApprove,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalApprove,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to reject this order?</Text>
        </Modal.Section>
      </Modal>
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default OrderDetails;
